import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { clearAccessToken } from "../../api/axiosInstance";

function Sidebar() {
  const navigate = useNavigate();

  const logOut = async () => {
    try {
      await userAPI.logOut();

      clearAccessToken();
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");

      navigate("/");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="custom-profile-sidebar p-4">
      <div className="profile-nav-links d-flex d-lg-block">
        <div>
          <NavLink
            to="/users/dashboard"
            className={({ isActive }) =>
              `custom-sidebar-link ${isActive ? "active" : ""}`
            }
          >
            Dashboard
          </NavLink>
        </div>
        <div>
          <NavLink
            to="/users/orders"
            className={({ isActive }) =>
              `fw-medium custom-sidebar-link ${isActive ? "active" : ""}`
            }
          >
            My Orders
          </NavLink>
        </div>
        <div>
          <NavLink
            to="/users/addresses"
            className={({ isActive }) =>
              `fw-medium custom-sidebar-link ${isActive ? "active" : ""}`
            }
          >
            Addresses
          </NavLink>
        </div>
        <div>
          <NavLink
            to="/users/account"
            className={({ isActive }) =>
              `fw-medium custom-sidebar-link ${isActive ? "active" : ""}`
            }
          >
            Account Details
          </NavLink>
        </div>
        <div>
          <NavLink
            to="/users/change-password"
            className={({ isActive }) =>
              `fw-medium custom-sidebar-link ${isActive ? "active" : ""}`
            }
          >
            Change Password
          </NavLink>
        </div>
        <div>
          <NavLink
            onClick={(e) => logOut()}
            className={({ isActive }) =>
              `fw-medium custom-sidebar-link ${isActive ? "active" : ""}`
            }
          >
            Logout
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
